<template>
  <div class="page">
    <!-- 顶部主视觉（静态视觉图） -->
    <img class="top-banner"
      src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-n-member-kv" alt="" />

    <!-- 转介人卡片 -->
    <div class="inviter-card">
      <div class="inviter-head">
        <img class="avatar" :src="inviter.avatar" alt="" />
        <div class="head-info">
          <span class="name">{{ inviteText }}</span>
          <span class="desc">登录app解锁更多互动</span>
        </div>
      </div>
    </div>

    <!-- 底部：说明 + 领取按钮 -->
    <img class="receive-btn"
      src="https://gympic.gymcity.com.cn/uploads-add/202609/2026-09-29-zxg-invite-activity-n-member-button"
      @click="onReceiveBtnClick" alt="" />

    <!-- 领取信息填写弹窗 -->
    <ReceiveInputPopup ref="receiveInput" v-model="showReceive" :inviter="inviter" :agreements="agreements"
      :user-id="referrerIdForTrack" @confirm="onReceiveConfirm" />
    <!-- 领取结果弹窗 -->
    <ReceiveResultPopup v-model="showResult" :type="resultType" :message="resultMessage" @download="onDownload" />
  </div>
</template>
<script>
import ReceiveInputPopup from './ponents/ReceiveInputPopup.vue'
import ReceiveResultPopup from './ponents/ReceiveResultPopup.vue'

export default {
  components: { ReceiveInputPopup, ReceiveResultPopup },
  data() {
    return {
      code: '', // 转介唯一码（分享链接携带）
      inviter: {}, // 转介人信息 { nickname, phone_masked, user_id }
      agreements: [], // 场景下发的协议列表（按 code 勾选后透传给 claim）
      showReceive: false,
      showResult: false,
      resultType: 'success', // success | fail
      resultMessage: '',
      referrerId: 0 // 转介人 user_id（来自 /api/referral/member 接口，埋点携带）
    }
  },
  computed: {
    inviteText() {
      const name = this.inviter.nickname || '你的好友'
      return name + ' 邀你组搭子一起运动~'
    },
    // 埋点携带的转介人 user_id（接口未返回则记 0）
    referrerIdForTrack() {
      return this.referrerId || (this.inviter && this.inviter.user_id) || 0
    }
  },
  created() {
    // 新会员领卡页曝光埋点需拿到转介人 user_id（来自 /api/referral/member 接口），
    // 放到 getInviter 成功回调里统一发
    this.code = this.$route.query.code || ''
    this.getInviter()
    this.getAgreements()
  },
  methods: {
    // 「领取」按钮：打开注册信息弹窗
    onReceiveBtnClick() {
      // 「领取」按钮点击埋点
      this.$http.bindH5UMA('zxg_referral_202610_claim_btn_click', this.referrerIdForTrack)
      // 注册信息弹窗曝光埋点
      this.$http.bindH5UMA('zxg_referral_202610_register_page_view', this.referrerIdForTrack)
      this.showReceive = true
    },
    // 转介人信息（复用 member 接口，新会员侧用 code 查询）
    getInviter() {
      if (!this.code) {
        return
      }
      this.$http
        .postArena('/api/referral/member', { code: this.code })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.inviter = res.data.user || {}
            this.referrerId = this.inviter.user_id || 0
            document.title = `${this.inviter.nickname || '邀请你一起训练'}`
            // 新会员领卡页曝光埋点（接口返回转介人 user_id 后再发）
            this.$http.bindH5UMA(
              'zxg_referral_202610_claim_page_view',
              this.referrerIdForTrack
            )
          }
        })
        .catch(() => { })
    },
    // 场景下发的协议列表（领卡必勾，弹窗里展示）
    getAgreements() {
      this.$http
        .getArena('/api/v1/covenant/list', { sceneType: 'VENUE_CARD_TRIAL' })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.agreements = (res.data && res.data.agreements) || []
          }
        })
        .catch(() => { })
    },
    // 确认领取：手机号 + 验证码 + 转介唯一码 + 勾选协议 code
    onReceiveConfirm({ phone, smsCode, agreedProtocols }) {
      this.$http
        .postArena('/api/referral/claim', {
          phone,
          sms_code: smsCode,
          referral_code: this.code,
          client_order_token: this.createOrderToken(),
          agreed_protocols: agreedProtocols || [],
          coach_id: Number(this.$route.query.coach_id || 0)
        })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            // 领取成功才关闭输入弹窗，并清空表单（手动关闭时表单保留）
            this.$refs.receiveInput.reset()
            this.showReceive = false
            this.resultType = 'success'
            // 领卡成功页曝光埋点
            this.$http.bindH5UMA('zxg_referral_202610_claim_success_page_view', this.referrerIdForTrack)
            // 后端给出的 C 端文案（开业前/后不同）
            this.resultMessage =
              (res.data && res.data.sms_text_hint) ||
              '场地卡将于开业时（10月28日）统一激活，请及时使用~'
          } else {
            // 领取失败：输入弹窗保持打开（手机号/验证码保留可改），失败弹窗叠加提示
            this.resultType = 'fail'
            this.resultMessage = res.msg || '领取失败，请稍后重试'
          }
          this.showResult = true
        })
        .catch(() => {
          // 网络异常：与领取失败同样走结果弹窗，需用户点击关闭
          this.resultType = 'fail'
          this.resultMessage = '网络异常，请稍后重试'
          this.showResult = true
        })
    },
    // 下单幂等令牌（UUIDv4）
    createOrderToken() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
    // 成功弹窗：下载app
    onDownload() {
      // 「下载 App」按钮点击埋点
      this.$http.bindH5UMA('zxg_referral_202610_app_download_btn_click', this.referrerIdForTrack)
      this.showResult = false
      if (this.$betterwe.isApp()) {
        return
      }
      // TODO 跳转 App 下载页，地址待确认
      this.$router.push('/app-download')
      // window.location.href = 'https://app.gymcity.com.cn/download'
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  position: relative;
  background: #ff9935;
  min-height: 100vh;
  overflow: hidden;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
}

.top-banner {
  position: absolute;
  display: block;
  width: 100%;
  left: 0;
  top: 0;
}

.inviter-card {
  position: relative;
  padding: 131px 16px 0px;

  .inviter-head {
    display: flex;
    padding: 12px 16px 12px;
    box-sizing: border-box;

    .avatar {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      object-fit: cover;
      flex-shrink: 0;
    }

    .head-info {
      display: flex;
      flex-direction: column;
      margin: 8px 0 4px 12px;

      .name {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }

      .desc {
        margin-top: 6px;
        font-size: 12px;
        font-family: MiSans-Normal, MiSans;
        color: #000;
        line-height: 18px;
      }
    }
  }
}

.receive-btn {
  position: fixed;
  left: 0;
  bottom: 20px;
  width: 375px;
}
</style>
